module.exports = __webpack_public_path__ + "h5/img/button-tip.a0bfa455.png";